const toggle = document.getElementById('ts-search-toggle');
const overlay = document.getElementById('ts-search-overlay');
const closeBtn = document.getElementById('ts-search-close');
const input = document.getElementById('ts-search-overlay-input');

if (toggle && overlay && closeBtn && input) {
  const open = () => {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    window.setTimeout(() => input.focus(), 50);
  };

  const close = () => {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', open);
  closeBtn.addEventListener('click', close);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('open')) close();
  });
}
